<template>
  <b-modal size="lg" scrollable v-model="show" centered title="Weiterleitungs-Chat öffnen">
    <b-row>
      <b-col>
        <b-table hover responsive  id="my-table"
                 :items="forwards"
                 :fields="fields"
                 selectable
                 select-mode="single"
                 @row-selected="onRowSelected"
        >
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="cancel">
        Abbrechen
      </b-button>
      <b-button size="md"  variant="success" :disabled="!canContinue" @click="onFinish">
        Chat öffnen
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "task_messaging_forwards_dialog",
  props:{
    forwards: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    canContinue() {
      return this.selected.length === 1;
    },
  },
  data: () => {
    return {
      items: [],
      selected: [],
      show: false,
      fields: [
        {key: 'create_date', label: 'Geteilt am', formatter: (value, key, item) => {
            if (value === null) {
              return ""
            }
            let event = new Date(value.replace('Z',''));
            let options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: "2-digit", minute: "2-digit" };
            return event.toLocaleDateString('de-DE', options);
          }},
        {key: 'users', label: 'Nutzer im Chat', formatter: (value, key, item) => {
            if (value === null) {
              return ""
            }
            let res = "";
            for (let i = 0; i < value.length; i++) {
              let u = JSON.parse(sessionStorage.getItem(value[i]._id));
              if (u !== null) {
                res += u.first_name + " " + u.surname + ", ";
              }
            }
            res.replace(/, $/, '')
            return res;
          }},
      ]
    }
  },
  methods: {
    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: "2-digit", minute: "2-digit" };
      return event.toLocaleDateString('de-DE', options);
    },
    usersInChat(value) {
      if (value === null) {
        return ""
      }
      let res = "";
      for (let i = 0; i < value.length; i++) {
        res += value[i]._id;
      }
      return res;
    },
    onFinish() {
      this.show = false;
      this.$emit("open-chat", this.selected[0])
    },
    showModal() {
      this.$nextTick(() => {
        this.show = true;
      })
    },
    onRowSelected(items) {
          this.selected = items;
    },
  }
}
</script>
<style>
.table-cursor {
  cursor: pointer;
}
</style>
